export default "__VITE_ASSET__B2AQq3zQ__"